

export const columns_purchase = [
  {
    title: "入库单号",
    dataIndex: "inboundCode",
    key: "inboundCode",
    rowKey: "key",
    width:200,
    scopedSlots: {
      customRender: "inboundCode",
    },
  },
  {
    title: "入库类型",
    dataIndex: "inboundType",
    key: "inboundType",
    rowKey: "key",
    width:140,
    customRender:(text, record, index)=>{
      return {1:'手动入库',2:'调拨入库',0:'采购入库'}[text]
    }
  },
  {
    title: "业务类型",
    dataIndex: "purchaseType",
    key: "purchaseType",
    rowKey: "key",
    width:140,
    customRender:(text, record, index)=>{
      return {1:'OEM大货单',2:'OEM样品单',3:'档口采购',4:'马帮入库',0:'线上采购'}[text]
    }
  },
  {
    title: "采购单号",
    key: "purchaseNoList",
    dataIndex: "purchaseNoList",
    rowKey: "key",
    width:240,
    customRender:(text, record, index)=>{
      // return record.purchaseNoList.reduce((text,item)=>{
      //   return `${item},${text}`
      // },'')
      return record.purchaseNoList.join(',')
    }
  },
  {
    title: "物流单号",
    key: "expressNoList",
    dataIndex: "expressNoList",
    rowKey: "key",
    scopedSlots: {
      customRender: "expressNoList",
    },
  },
  {
    title: "商品数量",
    key: "nums",
    dataIndex: "nums",
    rowKey: "key",
    width:120,
  },
  {
    title: "状态",
    key: "status",
    dataIndex: "status",
    rowKey: "key",
    width:140,
    customRender:(text, record, index)=>{
      return {1:'待签收',2:'入库中',3:'待确认',4:'已完成',5:'已关闭'}[text]
    }
  },
  {
    title: "创建人",
    key: "creatorName",
    dataIndex: "creatorName",
    rowKey: "key",
  },
  {
    title: "创建时间",
    key: "createTime",
    dataIndex: "createTime",
    rowKey: "key",
    width: 200,
  }
];

export const columns = [
  {
    title: "入库单号",
    dataIndex: "inboundCode",
    key: "inboundCode",
    rowKey: "key",
    scopedSlots: {
      customRender: "inboundCode",
    },
  },
  {
    title: "入库类型",
    dataIndex: "inboundType",
    key: "inboundType",
    rowKey: "key",
    customRender:(text, record, index)=>{
      return {1:'手动入库',2:'调拨入库',0:'采购入库'}[text]
    }
  },
  {
    title: "状态",
    dataIndex: "status",
    key: "status",
    rowKey: "key",
    customRender:(text, record, index)=>{
      return {1:'待签收',2:'入库中',3:'待确认',4:'已完成',5:'已关闭'}[text]
    }
  },
  {
    title: "客户ID",
    key: "customerId",
    dataIndex: "customerId",
    rowKey: "key",
  },
  {
    title: "客户名称",
    key: "unificationCustomerFullName",
    dataIndex: "unificationCustomerFullName",
    rowKey: "key",
  },
  {
    title: "店铺名称",
    key: "customerShopName",
    dataIndex: "customerShopName",
    rowKey: "key",
  }
];

export const columns_son = [
  {
    title: "图片",
    key: "productImg",
    dataIndex: "productImg",
    rowKey: "key",
    width: 70,
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  {
    title: "平台SKU",
    key: "productSku",
    dataIndex: "productSku",
    rowKey: "key",
    scopedSlots: {
      customRender: "productSku",
    },
  },
  {
    title: "商品名",
    key: "productName",
    dataIndex: "productName",
    rowKey: "key",
    ellipsis: true,
  },
  {
    title: "商品规格",
    key: "productProp",
    dataIndex: "productProp",
    rowKey: "key",
    width: 300,
    scopedSlots: {
      customRender: "productProp",
    },
  },
  {
    title: "马帮SKU",
    key: "thirdProductSku",
    dataIndex: "thirdProductSku",
    rowKey: "key",
  },
  {
    title: "表格导入数量",
    key: "importNum",
    dataIndex: "importNum",
    rowKey: "key",
    width: 120
  },
  {
    title: "未入库数量",
    key: "unImportNum",
    dataIndex: "unImportNum",
    rowKey: "key",
    width: 120
  },
  {
    title: "已入库数量",
    key: "realImportNum",
    dataIndex: "realImportNum",
    rowKey: "key",
    width: 120
  },
  {
    title: "取消数量",
    key: "cancelNum",
    dataIndex: "cancelNum",
    rowKey: "key",
    width: 120
  },
  {
    title: "库位",
    key: "gridCode",
    dataIndex: "gridCode",
    rowKey: "key",
  },
  {
    title: "操作",
    key: "action_son",
    dataIndex: "action_son",
    rowKey: "key",
    width: 200,
    fixed: "right",
    scopedSlots: {
      customRender: "action_son",
    },
  },
];

export const columns_son_purchase = [
  {
    title: "图片",
    key: "productImg",
    dataIndex: "productImg",
    rowKey: "key",
    width: 70,
    scopedSlots: {
      customRender: "productImgAction",
    },
  },
  {
    title: "平台SKU",
    key: "productSku",
    dataIndex: "productSku",
    rowKey: "key",
    scopedSlots: {
      customRender: "productSku_purchase",
    },
  },
  {
    title: "商品名",
    key: "productName",
    dataIndex: "productName",
    rowKey: "key",
    ellipsis: true,
  },
  {
    title: "商品规格",
    key: "productProp",
    dataIndex: "productProp",
    rowKey: "key",
    ellipsis: true,
    width: 200,
  },
  {
    title: "购买数量",
    key: "purchaseNum",
    dataIndex: "purchaseNum",
    rowKey: "key",
    scopedSlots: {
      customRender: "purchaseNum",
    },
    width: 120
  },
  {
    title: "已入库数量",
    key: "inboundNum",
    dataIndex: "inboundNum",
    rowKey: "key",
    scopedSlots: {
      customRender: "realImportNum",
    },
    width: 120
  },
  {
    title: "异常上报客户数",
    key: "exceptionCustomerNum",
    dataIndex: "exceptionCustomerNum",
    rowKey: "key",
    scopedSlots: {
      customRender: "exceptionCustomerNum",
    },
    width: 140
  },
  {
    title: "异常上报采购数",
    key: "exceptionPurchaseNum",
    dataIndex: "exceptionPurchaseNum",
    rowKey: "key",
    scopedSlots: {
      customRender: "exceptionPurchaseNum",
    },
    width: 140
  },
  {
    title: "次品数",
    key: "badNum",
    dataIndex: "badNum",
    rowKey: "key",
    scopedSlots: {
      customRender: "badNum",
    },
    width: 120
  }
];

export const handleAction = 
{
  title: "操作",
  key: "action",
  dataIndex: "action",
  rowKey: "key",
  width: 200,
  fixed: "right",
  scopedSlots: {
    customRender: "action",
  },
}

export const closeColums = [
  {
    title: "关闭人",
    key: "closeName",
    dataIndex: "closeName",
    rowKey: "key",
  },
  {
    title: "关闭时间",
    key: "closeTime",
    dataIndex: "closeTime",
    rowKey: "key",
  },
  {
    title: "关闭原因",
    key: "closeReason",
    dataIndex: "closeReason",
    rowKey: "key",
    scopedSlots: {
      customRender: "closeReason",
    },
  }
]
